module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSection) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Rights Management for User With Approval Flow - ALL PURCHASES - Expenses Flow")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n        Shipment Type\n        "), (_vm.requireValidation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('CustomMultiSelect', {
    attrs: {
      "options": _vm.shipmentTypeList,
      "selected-options": _vm.shipmentType_items,
      "placeholder": "Select Shipment Type",
      "multiple": true,
      "error-class": _vm.getErrorClass('ape_shipment_type')
    },
    on: {
      "select": _vm.SelectMultishipmentType
    },
    model: {
      value: (_vm.localData.ape_shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.localData, "ape_shipment_type", $$v)
      },
      expression: "localData.ape_shipment_type"
    }
  }), _vm._v(" "), (_vm.requireValidation && _vm.validationTriggered && (!_vm.localData.ape_shipment_type || _vm.localData.ape_shipment_type.length === 0)) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessages.ape_shipment_type) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n        Module Type\n        "), (_vm.requireValidation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('CustomMultiSelect', {
    attrs: {
      "options": _vm.moduelTypeList,
      "selected-options": _vm.moduelType_items,
      "placeholder": "Select Module Type",
      "multiple": true,
      "error-class": _vm.getErrorClass('ape_moduel_type')
    },
    on: {
      "select": _vm.SelectMultimoduelType
    },
    model: {
      value: (_vm.localData.ape_moduel_type),
      callback: function($$v) {
        _vm.$set(_vm.localData, "ape_moduel_type", $$v)
      },
      expression: "localData.ape_moduel_type"
    }
  }), _vm._v(" "), (_vm.requireValidation && _vm.validationTriggered && (!_vm.localData.ape_moduel_type || _vm.localData.ape_moduel_type.length === 0)) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessages.ape_moduel_type) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n        Job Type\n        "), (_vm.requireValidation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('CustomMultiSelect', {
    attrs: {
      "options": _vm.jobTypeList,
      "selected-options": _vm.jobType_items,
      "placeholder": "Select Job Type",
      "multiple": true,
      "error-class": _vm.getErrorClass('ape_job_type')
    },
    on: {
      "select": _vm.SelectMultijobType
    },
    model: {
      value: (_vm.localData.ape_job_type),
      callback: function($$v) {
        _vm.$set(_vm.localData, "ape_job_type", $$v)
      },
      expression: "localData.ape_job_type"
    }
  }), _vm._v(" "), (_vm.requireValidation && _vm.validationTriggered && (!_vm.localData.ape_job_type || _vm.localData.ape_job_type.length === 0)) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessages.ape_job_type) + "\n      ")]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f715df9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/RightsManagementComponent.vue
// module id = 2393
// module chunks = 0